import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconPaymentCheck.tsx
const IconPaymentCheck = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsxs("g", {
		fill: "currentColor",
		children: [
			/* @__PURE__ */ jsx("path", { d: "m23.8 27.666 6.6-6.6-1.886-1.885-4.714 4.714-2.828-2.828-1.886 1.885z" }),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				d: "M15.9 17.24a1.57 1.57 0 0 1 1.575-1.563h12.522l-.01-9.77c0-.868-.7-1.573-1.563-1.573l-25.25.01c-.868 0-1.574.7-1.574 1.564l.01 15.519c0 .868.7 1.573 1.564 1.573H15.9zm-9.843-3.878V7.667h4.524q1.395 0 2.361.504.967.498 1.465 1.354.504.849.504 1.91 0 1.1-.51 1.939-.51.831-1.476 1.307-.967.468-2.344.469H8.225v.89h2.631v1.787h-2.63v1.84h-2.17v-1.84H4.295V16.04h1.763v-.89H4.294v-1.788z",
				clipRule: "evenodd"
			}),
			/* @__PURE__ */ jsx("path", { d: "M10.581 9.472q.732 0 1.207.263.48.258.714.71.24.445.235 1.008.005.573-.235 1a1.6 1.6 0 0 1-.726.668q-.486.24-1.242.241H8.225v-3.89z" })
		]
	})]
});
var IconPaymentCheck_default = forwardRef(IconPaymentCheck);
//#endregion
export { IconPaymentCheck_default as default };
